import {
    FETCH_IOS,
    FETCH_IOSS,
} from '../actions/ios';


export const initialState = {
    isFetching: true,
    data: null
};

export const ioss = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_IOSS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_IOSS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}

export const ios = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_IOS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_IOS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.payload.data,
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/ios.js